"use strict";
/*
 * Created on 03 10 2019
 */

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var StructPropBuilder_1 = require("../../core/model/data-dictionary/StructPropBuilder");

var DomainObject_1 = require("../../core/model/DomainObject");
/**
 * <p>
 * This object encapsulates suppliers of product, more respectively preferred supplier and possible other suppliers of product.
 * </p>
 *
 * <p>
 * It is important to note, that this object is only data transfer object and encapsulated data are determined based on params,
 * mainly group of sites. There can be multiple preferred suppliers of product within given group of sites, but only one preferred
 * supplier delivering to single site. The preferred supplier is selected on frequency basis.
 * </p>
 *
 * @author JMe
 */


var ProductSuppliers =
/*#__PURE__*/
function (_DomainObject_1$Domai) {
  _inherits(ProductSuppliers, _DomainObject_1$Domai);

  /**
   * @param productId id of internal product
   * @param preferredSupplierId preferred supplier if any
   * @param supplierIds list of non preferred suppliers (suppliers that have not been identified as preferred by the algorithm)
   */
  function ProductSuppliers(productId, preferredSupplierId, supplierIds) {
    var _this;

    _classCallCheck(this, ProductSuppliers);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(ProductSuppliers).call(this));
    _this.productId = productId;
    _this.preferredSupplierId = preferredSupplierId;
    _this.supplierIds = supplierIds;
    return _this;
  }

  return ProductSuppliers;
}(DomainObject_1.DomainObject);

exports.ProductSuppliers = ProductSuppliers;

ProductSuppliers.schema = function () {
  var builder = new StructPropBuilder_1.StructPropBuilder(ProductSuppliers.name);
  return {
    productId: builder.id('productId'),
    preferredSupplierId: builder.opt(builder.id('preferredSupplierId')),
    supplierIds: builder.setOf(builder.id('supplierIds'))
  };
}();